export default "__VITE_ASSET__CKsDzNUJ__"